import { html } from 'lit';
import { customElement } from 'lit/decorators.js';

import i18n from 'portal-base/src/decorators/i18n';

import { dsViewStyles } from 'ds-shared-lib/src/base/css/ki-ds-view-styles.css';

import nls from '../../locales/indexes.nls';
import { getAlarmData } from '../../services/alarming';
import { fetchChannelMetaData, getChannelIdFromUrl } from '../../services/channel';
import { showToast } from '../../services/toast-service';
import KiDsPwaView from '../pwa-view/ki-ds-pwa-view';
import styles from './alarmstatus-view.css';
import '../../components/ki-ds-pwa-alarm-status/ki-ds-pwa-alarm-status';

const CLASS_NAME = 'alarm-status-view';

@i18n(nls)
@customElement(CLASS_NAME)
class KiDsPwaAlarmStatusView extends KiDsPwaView {
    static styles = [...dsViewStyles, styles];

    static get properties() {
        return {
            alarmStatus: { type: Array },
            isLoading: { type: Boolean },
        };
    }

    constructor() {
        super();
        this.alarmStatus = [];
        this.isLoading = true;
    }

    async firstUpdated() {
        super.firstUpdated();
        await this._loadView();
    }

    async _loadView() {
        this.isLoading = true;
        try {
            this.channelId = getChannelIdFromUrl();

            const channel = await fetchChannelMetaData(this.channelId);
            this._setDocumentTitle(channel);
            this._dispatchChannelLoaded(channel);

            if (channel.channelFeatures?.alarming) {
                await this._loadAlarmData();
            }
        } catch (_err) {
            showToast({ content: 'Failed to load alarm data', type: 'error' });
        } finally {
            this.isLoading = false;
        }
    }

    async _loadAlarmData() {
        const alarmData = await getAlarmData(this.channelId);
        this.alarmStatus = alarmData.alarmStatus;
    }

    render() {
        return html`
            <div class="view">
                <ki-ds-pwa-alarm-status
                    .statusList=${this.alarmStatus}
                    .isLoading=${this.isLoading}
                ></ki-ds-pwa-alarm-status>
            </div>
        `;
    }
}
